import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import styled from 'styled-components';
import CardInfo from '../../components/cards/CardInfo';
import CheckList, { CheckItem } from '../../components/CheckList';
import MainLayout, { LayoutHeading } from '../../components/MainLayout';
import useConfig from '../../context/config.context';
import useSteps from '../../context/steps.context';
import spreadIf from '../../helpers/spreadIf';
import useAccountSummary from '../../hooks/useAccountSummary';
import useCardholders from '../../hooks/useCardholders';
import { t } from '../../translations/getTranslation';
const ListContainer = styled.div `
  margin-top: ${({ theme }) => theme.spacing.large}px;
`;
const isAccountChecked = (cardholders, targetAccount) => cardholders.some(cardholder => cardholder.id === targetAccount.id);
const SelectAccount = () => {
    const { stepsState: { error }, stepsDispatch } = useSteps();
    const { triggerAnalyticsEvent } = useConfig();
    const { cardholders, selectedCardholders } = useCardholders('SelectAccount');
    const { isSuccess, isSemu } = useAccountSummary();
    const errorText = t('selectAccount.selectOneOrMore');
    useEffect(() => {
        if (!isSuccess) {
            return;
        }
        triggerAnalyticsEvent({
            messageType: isSemu ? 'semu' : 'nonsemu',
            pageFunction: 'replace your card',
            pageSubFunction: 'damaged card',
            pageKind: 'account services',
            pageName: 'cardholder selection'
        });
    }, [triggerAnalyticsEvent, isSemu, isSuccess]);
    const handleAccountToggle = (event) => {
        const target = event.currentTarget;
        /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
        const selectedAccount = cardholders.find(cardholder => cardholder.id === target.id);
        if (error) {
            stepsDispatch({ type: 'clearError' });
        }
        const newCardholders = isAccountChecked(selectedCardholders, selectedAccount)
            ? selectedCardholders.filter(cardholder => cardholder.id !== selectedAccount.id)
            : [...selectedCardholders, selectedAccount];
        stepsDispatch({
            type: 'updateAnswer',
            payload: {
                step: 'SelectAccount',
                value: newCardholders
            }
        });
    };
    const handleAccountToggleAll = () => {
        const allChecked = cardholders.every(cardholder => isAccountChecked(selectedCardholders, cardholder));
        if (error) {
            stepsDispatch({ type: 'clearError' });
        }
        const newCardholders = allChecked ? [] : cardholders;
        stepsDispatch({
            type: 'updateAnswer',
            payload: { step: 'SelectAccount', value: newCardholders }
        });
    };
    return (_jsxs("div", Object.assign({ id: "select-account-view" }, { children: [_jsx(CardInfo, {}), _jsxs(MainLayout, Object.assign({ withImage: true }, { children: [_jsx(LayoutHeading, Object.assign({ modalImageProps: { imageName: 'DISPUTE_TRANSACTION' }, title: t('selectAccount.whichCardholder') }, spreadIf([error, { errorText }]))), _jsx(ListContainer, { children: _jsx(CheckList, { selectAllAnalytics: {
                                dataType: 'replacement card',
                                dataObject: 'button',
                                dataAnalytics: 'clicktrackingevent'
                            }, items: cardholders.map(cardholder => {
                                const isChecked = isAccountChecked(selectedCardholders, cardholder);
                                const { id, name, last4digits } = cardholder;
                                return {
                                    headingLabel: name,
                                    subtext: t('common.accountEndingIn', {
                                        last4digits
                                    }),
                                    checkboxAnalytics: {
                                        /* TODO: remove mock dataReason */
                                        dataReason: 'primary cardholder',
                                        dataType: 'not placed',
                                        dataObject: isChecked
                                            ? 'checkbox-select'
                                            : 'checkbox-unselect',
                                        dataAnalytics: 'clicktrackingevent'
                                    },
                                    checkboxProps: {
                                        id,
                                        onChange: handleAccountToggle,
                                        isChecked
                                    },
                                    hasError: !!error
                                };
                            }), renderItem: props => _jsx(CheckItem, Object.assign({}, props)), onToggleCheckAll: handleAccountToggleAll }) })] }))] })));
};
export default SelectAccount;
//# sourceMappingURL=index.js.map